"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16PeopleGroupLine = function Svg16PeopleGroupLine(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 20a2 2 0 0 0 2-2c0-.5-.13-.954-.13-.954a4.893 4.893 0 0 0-.833-1.746C14.52 13.943 12.739 13 10 13s-4.52.943-5.537 2.3a4.892 4.892 0 0 0-.833 1.746S3.5 17.5 3.5 18a2 2 0 0 0 2 2h9zm0-2s0-1.127-1.037-2c-.654-.55-1.722-1-3.463-1s-2.809.45-3.463 1C5.5 16.873 5.5 18 5.5 18h9zM14 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0zm-4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    d: "M16.738 14.4c.273.365.487.73.654 1.08.385.804.608 1.641.608 2.52a3.5 3.5 0 0 1-.145 1h.645a2 2 0 0 0 2-2c0-.846-.383-1.689-.932-2.317-.883-1.009-2.288-1.62-4.256-1.678a6.57 6.57 0 0 1 1.426 1.395z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 12a3.5 3.5 0 1 0-.377-6.98c.555.859.877 1.882.877 2.98a5.482 5.482 0 0 1-1.56 3.837c.335.106.69.163 1.06.163z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16PeopleGroupLine.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16PeopleGroupLine;
exports.default = _default;